import { render, staticRenderFns } from "./PayBills.vue?vue&type=template&id=5920d27c&scoped=true&"
import script from "./PayBills.vue?vue&type=script&lang=js&"
export * from "./PayBills.vue?vue&type=script&lang=js&"
import style0 from "./PayBills.vue?vue&type=style&index=0&id=5920d27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920d27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
